import { render, staticRenderFns } from "./newIntro.vue?vue&type=template&id=29b0d041&"
import script from "./newIntro.vue?vue&type=script&lang=js&"
export * from "./newIntro.vue?vue&type=script&lang=js&"
import style0 from "./newIntro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports